export const GET_ALL_FORMS_BEGIN = "GET_ALL_FROMS_BEGIN";
export const GET_ALL_FORMS_SUCCESS = "GET_ALL_FROMS_SUCCESS";
export const GET_ALL_FORMS_ERROR = "GET_ALL_FROMS_ERROR";
export const GET_ALL_FORMS_GROUP_BEGIN = "GET_ALL_FROMS_GROUP_BEGIN";
export const GET_ALL_FORMS_GROUP_SUCCESS = "GET_ALL_FROMS_GROUP_SUCCESS";
export const GET_ALL_FORMS_GROUP_ERROR = "GET_ALL_FROMS_GROUP_ERROR";
